<template>
  <base-chips
    class="percent-chips"
    :is-initialized="isInitialized"
    :items="labels"
    secondary-text
    @chip-selected="onChipClick"
  />
</template>

<script>
import Utils from '@emcd-shared/utils/formatters'
import { toFixed } from '@/shared/lib/toFixed'
import { BaseChips } from '@/shared/ui/BaseChips'

export default {
  props: {
    // To show skeleton or chips
    isInitialized: {
      type: Boolean,
    },
    // Object with current selected fiat description
    fiat: {
      type: Object,
    },
  },
  emits: ['chip-selected'],

  components: {
    BaseChips,
  },

  computed: {
    labels() {
      const amountsMap = {
        RUB: [1000, 5000, 10000, 25000, 50000],
        USD: [10, 50, 100, 500, 750, 1000],
        EUR: [10, 50, 100, 500, 750, 1000],
      }
      const defaultAmounts = [1000, 5000, 10000, 25000, 50000]
      const amounts = amountsMap[this.fiat?.value] ?? defaultAmounts
      return amounts.map(this.formatFiatAmount)
    },
  },

  methods: {
    onChipClick(label) {
      const numericValue = parseFloat(label.replace(/\D/g, ''))
      this.$emit('chip-selected', toFixed(numericValue))
    },

    formatFiatAmount(value) {
      if (value === undefined || this.fiat === undefined) return ''
      return Utils.formatCurrency(
        value,
        this.fiat?.value,
        0,
        false,
        'floor',
        {},
        this.$i18n.locale
      )
    },
  },
}
</script>

<style scoped>
.percent-chips {
  margin-top: 10px;
}
</style>
